import { ref, watch, type Ref } from 'vue'


export const useAutocompletionHelper = <T>(items: Ref<Array<T>>, search: Ref<unknown>, select?: (v: T) => unknown) => {
  const counter = ref(-1)

  const up = () => {
    counter.value -= counter.value >= 0 ? 1 : 0
  }

  const down = () => {
    counter.value += counter.value < items.value.length - 1 ? 1 : 0
  }

  const enter = () => {
    if (counter.value !== -1 && items.value[counter.value]) {
      return select?.(items.value[counter.value]!)
    }
  }

  watch(search, () => counter.value = -1)
  watch(items, () => counter.value = -1)

  return { counter, up, down, enter }
}